import { render, staticRenderFns } from "./register-case-layout.vue?vue&type=template&id=78f42606&scoped=true&"
import script from "./register-case-layout.vue?vue&type=script&lang=ts&"
export * from "./register-case-layout.vue?vue&type=script&lang=ts&"
import style0 from "./register-case-layout.vue?vue&type=style&index=0&id=78f42606&lang=scss&scoped=true&"
import style1 from "./register-case-layout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f42606",
  null
  
)

export default component.exports